import type { FeatureName } from 'v5/platform/feature-management/feature-management';
import type { AtellioFeatureGroupDefinition } from 'v5/features';

/**
 * Layer-1 shell chrome flags — always resolve against the organization (legacy)
 * set, never the browsing workspace. See workspace-scoping-layers.mdc.
 */
export const SHELL_FEATURE_FLAGS = new Set<
  FeatureName<AtellioFeatureGroupDefinition>
>(['enterprise', 'manage-enterprise', 'ported-v1-endpoints']);
